import {assert} from 'Asserts';
import {ManagedModelType, ManagedModelTypes} from 'models/ManagedModelDefinitions';
import {ModelManager} from 'models/managers/ModelManager';
import {getLoadingState, LoadingState} from 'models/reduceLoadingState';
import {getStore} from 'redux-stores/Store';

export const ALL_KEY = 'ALL_KEY';

/**
 * A ModelManager that only supports fetching a "model" with the ALL_KEY to fetch all models from the backend.
 *
 * ManagedModelTypes[T] should generally be a collection type, like an array.
 */
export default abstract class AllModelManager<T extends ManagedModelType> extends ModelManager<T> {
  abstract doFetchAll(): Promise<void>;

  abstract getAll(): ManagedModelTypes[T] | null;

  doFetchMulti(keys: [typeof ALL_KEY]): Promise<void> {
    assert(keys.length === 1 && keys[0] === ALL_KEY, 'Only ALL_KEY is supported');
    return this.doFetchAll();
  }

  getModel(modelKey: typeof ALL_KEY): ManagedModelTypes[T] | null {
    assert(modelKey === ALL_KEY, 'Only ALL_KEY is supported');

    // Only consider fetched if the loadingState indicates that we explicitly fetched via ALL_KEY.
    // This means that the implementation of this.getAll does not need to manage this state itself.
    const {loadingState} = getStore().getState().models;
    const isLoaded = getLoadingState(loadingState, this.modelType, modelKey) === LoadingState.LOADED;
    if (!isLoaded) {
      return null;
    }

    return this.getAll();
  }
}
